import { render, staticRenderFns } from "./BaseCreateNewDropdown.vue?vue&type=template&id=2061a3a2&scoped=true"
import script from "./BaseCreateNewDropdown.vue?vue&type=script&lang=js"
export * from "./BaseCreateNewDropdown.vue?vue&type=script&lang=js"
import style0 from "./BaseCreateNewDropdown.vue?vue&type=style&index=0&id=2061a3a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2061a3a2",
  null
  
)

export default component.exports